export enum AuthType {
  None = 'none',
  IdTokenExchange = 'id_token_exchange',
}

export const authTypes = Object.values(AuthType).filter(e => isNaN(Number(e)));
